import * as React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import '@progress/kendo-theme-bootstrap/dist/all.css';
import { LoadingPanel } from '../LoadingPanel';

interface Props {
  exporting: boolean;
}

const ReportsLoadingPanel: React.FC<Props> = ({
  exporting,
}): React.ReactElement => {
  const loading: boolean = useSelector(
    (state: ApplicationState) => state.reportsReducer.isFetchingReportData
  );

  return (
    <React.Fragment>{(loading || exporting) && LoadingPanel}</React.Fragment>
  );
};

export default ReportsLoadingPanel;
